/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bell_Activity_ChangedInputs */

const en_bell_activity_changed = /** @type {(inputs: Bell_Activity_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`changed`)
};

/**
* | output |
* | --- |
* | "changed" |
*
* @param {Bell_Activity_ChangedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bell_activity_changed = /** @type {((inputs?: Bell_Activity_ChangedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bell_Activity_ChangedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bell_activity_changed(inputs)
});